export default {
  formatDuration: function (s) {
    if (Number.isNaN(s)) return "0:00";

    let pad = function (num, size) {
        return ("000" + num).slice(size * -1);
      },
      time = parseFloat(s).toFixed(3),
      hours = Math.floor(time / 60 / 60),
      minutes = Math.floor(time / 60) % 60,
      seconds = Math.floor(time - minutes * 60);
    if (hours > 0) return hours + ":" + pad(minutes, 2) + ":" + pad(seconds, 2);
    else return minutes + ":" + pad(seconds, 2);
  },
};

export function formatFileSize(bytes, decimals = 2) {
  if (bytes === 0) return "0 Bytes";
  let k = 1024;
  let dm = decimals < 0 ? 0 : decimals;
  let sizes = ["Bytes", "KB", "MB", "GB"];
  let i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
}
